import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${isLandingPage ? 'fixed' : ''}`}>
      <nav className="nav-container">
        <div className="logo">
          <Link to="/">
            <h1>Hostería Futaleufú</h1>
          </Link>
        </div>
        <button className={`burger-menu ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Menu">
          <svg className="burger-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {isMenuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </>
            )}
          </svg>
        </button>
        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>Inicio</Link>
          <Link to="/reservar" onClick={() => setIsMenuOpen(false)}>Reservar</Link>
          <Link to="/recomendaciones" onClick={() => setIsMenuOpen(false)}>Actividades</Link>
          <Link to="/gestionar-reservas" onClick={() => setIsMenuOpen(false)}>Gestionar Reservas</Link>
        </div>
      </nav>
    </header>
  );
};

export default Header; 